<template>
    <div class="editor-main">
        <div class="menubar-area">
            <div class="menubar-logo" @click="goHome">
                <img src="../assets//logo_wTVision_small.png" alt="">
                <span>ision</span>
            </div>
            <div class="menubar-items">
                <div class="menubar-user">
                    <img src="../assets/admin.png" alt="" title="Administrator Dashboard" @click="navToAdmin">
                </div>
                <div class="menubar-options" @click="showOptions" :class="{'menubar-options-disable':loading}">
                    <img src="../assets/settings.png" title="Options">
                </div>
                <div class="menubar-settings" @click="showSettings" :class="{'menubar-settings-disable':loading}">
                    <img src="../assets/options.png" title="Settings">
                </div>
                <div class="menubar-user">
                    <img src="../assets/logout.png" alt="" title="Logout" @click="navToLogout">
                </div>
            </div>
            <div class="menubar-presence" aria-label="Users online in project">
                <div v-for="u in presentUsers" :key="u.key" class="presence-dot" :title="u.email || 'unknown'" :style="dotStyle(u)" @click="onPresenceBadgeClick(u)">
                    {{ (u.email || '?').charAt(0).toUpperCase() }}
                </div>
            </div>            
        </div>
        <div class="editor-area">
            <div class="left-side-bar">
                <Thumbnail ref="thumbsRef" :projectId="currentProject?.id ?? null" :selectedId="selectedThumbnail?.id ?? null"  @onThumbnailSelected="onThumbnailSelected" @requestDelete="onThumbRequestDelete"  @requestUpload="onThumbRequestUpload"/>
            </div>
            <div class="middle-side">
                <span v-if="exporting"  class="exporter">Please Wait</span>
                <span v-if="exporting"  class="loader">Export&nbsp;ng</span>
                <span v-if="exporting"  class="downloader"></span>

                <div v-if="exporting" class="export-progress">
                    <div class="export-progress-label">{{ exportLabel }}</div>
                    <div class="export-progress-bar">
                        <div class="export-progress-fill" :style="{ width: exportPercent + '%' }"></div>
                    </div>
                </div>

                <span v-if="loading"  class="loader">Load&nbsp;ng</span>                
                <span v-if="loading"  class="downloader"></span>
                <div v-if="selectedThumbnail?.is_validated" class="validated-overlay">
                    <div class="validated-badge">Read-only: Validated Image</div>
                    <Button v-if="canRevertValidation" @click="unvalidateSelected" color="red">Revert Validation</Button>
                </div>
                <div v-if="selectedThumbnail?.is_invalidated" class="validated-overlay">
                    <div class="validated-badge" style="background:#7f1d1d">
                        {{ username }}
                    </div>
                    <div v-if="selectedThumbnail?.invalidate_notes" class="validated-badge" style="background:#1f2937">
                        {{ selectedThumbnail.invalidate_notes }}
                    </div>
                    <Button v-if="canCorrect" @click="markCorrected" color="green">Corrected</Button>
                </div>                
                <ImageCanvas ref="canvasRef" :image="selectedThumbnail" :highLightedLine="highlightedLine" :readOnly="!!selectedThumbnail?.is_validated" @onNewLine="onNewLine" @onDeleteLine="onDeleteLine"></ImageCanvas>
            </div>
            <div class="right-side-bar">
                <div class="labels-container">
                    <Labels ref="labelsRef" v-if="selectedThumbnail" :image="selectedThumbnail" :onNewLine="newLine" :onDeleteLine="oldLine" :readOnly="!!selectedThumbnail?.is_validated" mode="editor" @onLabelFocus="onLabelFocus" @onLabelChanged="onLabelChanged"/>
                </div>
            </div>
        </div>
        <div v-if="optionsMenuVisible" class="options-menu">
            <ul>
                <li @click="" class="options">
                    <img src="../assets/cloud_save.png" alt="Save To Cloud" title="Save">
                    <span>Save</span>
                </li>
                <li @click="createAndDownloadZipCSV" class="options">
                    <img src="../assets/download.png" alt="Export" title="Save">
                    <span>Export Masks</span>
                </li>                
            </ul>
        </div>
        <div v-if="settingsMenuVisible" class="settings-menu">
            <ul>
                <li @click="openRules" class="settings">
                    <img src="../assets/rules.png" alt="Rules" title="Export Rules">
                    <span>Rules</span>
                </li>
            </ul>
        </div>
        <ModalComponent v-model="isOpenRules" class="modal">
            <div class="rules-global-options">
                <div class="rule-row">
                    <label class="rule-text">Export Original Images</label>
                    <label class="switch">
                    <input type="checkbox" v-model="rules.exportImages" />
                    <span class="slider round"></span>
                    </label>
                </div>
                <div class="rule-row">
                    <label class="rule-text">Line Size (px)</label>
                    <input
                    class="color-input center-input"
                    type="text"
                    v-model="rules.lineSize"
                    placeholder="Line size"
                    />
                </div>
                <div class="rule-row">
                    <label class="rule-text">Export Size</label>
                    <div class="inline-inputs">
                    <input
                        class="color-input center-input"
                        type="text"
                        v-model="rules.exportWidth"
                        placeholder="width"
                    />
                    <span class="multiplier">x</span>
                    <input
                        class="color-input center-input"
                        type="text"
                        v-model="rules.exportHeight"
                        placeholder="height"
                    />
                    </div>
                </div>
                <div class="rule-row">
                    <label class="rule-text">Background Color</label>
                    <div class="rule-color-picker">
                        <input class="color-picker" type="color" v-model="rules.backgroundColor" />
                        <input
                        class="color-input center-input"
                        type="text"
                        v-model="rules.backgroundColor"
                        placeholder="eg.: black"
                        />
                    </div>
                </div>
            </div>

            <div class="rule-header">
                <span class="rule-header-text">Label</span>
                <font-awesome-icon class="rule-fill-colors-icon" :icon="['fas', 'fill-drip']" title="Increment Colors" @click="autoIncrementColors" />
                <font-awesome-icon class="rule-save-icon" :icon="['fas', 'save']" title="Save Rules" @click="saveRules" />
            </div>            
            <ul class="rule-list">
                <li v-for="rule in rules.rules" :key="rule.label">
                    <div class="rule-item">
                        <span class="rule-label">{{ rule.label }}</span>
                        <div class="rule-color">
                            <input class="color-picker" type="color" v-model="rule.color" />
                            <input class="color-input" type="text" v-model="rule.color" />
                            <font-awesome-icon class="color-delete" :icon="['fas', 'trash-can']" @click="deleteRule(rule)" />
                        </div>
                    </div>
                </li>
            </ul>
        </ModalComponent>
        <div v-show="shortcutToast.show || isHiding" class="shortcut-toast" :class="{ 'is-hiding': isHiding }" role="status" aria-live="polite">
            <span class="shortcut-kbd">{{ shortcutToast.combo }}</span>
            <span class="shortcut-desc">{{ shortcutToast.label }}</span>
        </div>
    </div>
</template>

<script lang="ts">
    import { defineComponent, ref, onMounted, computed, onBeforeUnmount, nextTick  } from "vue"
    import { useStore } from "vuex";
    import { useRouter } from "vue-router";
    import { Project, ImageInfo, Lines, Line, Rules, Rule, Point, Segment } from "../helpers/Interfaces";
    import Thumbnail from '../components/Thumbnails.vue';
    import ImageCanvas from "../components/ImageCanvas.vue";
    import Labels from "../components/Labels.vue";
    import Button from "../components/Button.vue";
    import JSZip from "jszip";
    import { saveAs } from "file-saver";
    import ProjectService from "@/services/Project";
    import { supabase } from '@/supabase';
    import ModalComponent from "@/components/ModelComponent.vue";
    import { subscriptionManager } from "@/realtime/SubscriptionManager";
    import Semaphore from "@/helpers/Semaphore";

    type ImageCanvasExpose = { updateLineLabel: (lineId: number, newLabel: string) => Promise<void> | void; };
    type ThumbsExpose = { scrollToImage: (imageId: number) => Promise<void> | void; };
    type ExportTask = { baseName: string; csv?: string; png?: Blob; };

    export default defineComponent ({
        components: {
            Thumbnail,
            ImageCanvas,
            Labels,
            ModalComponent,
            Button
        },
        setup(props) {
            const store = useStore();
            const router = useRouter();
            const canvasRef = ref<(InstanceType<typeof ImageCanvas> & ImageCanvasExpose) | null>(null);
            const loading = ref<boolean>(false);
            const exporting = ref<boolean>(false);
            const optionsMenuVisible = ref<boolean>(false);
            const settingsMenuVisible = ref<boolean>(false);
            const selectedThumbnail = ref<ImageInfo | null>(null);
            const highlightedLine = ref<Line | null>(null);
            const newLine = ref<Line | null>(null);
            const oldLine = ref<Line | null>(null);
            const isAdmin = ref(false);
            const isOpenRules = ref<boolean>(false);
            const rules = ref<Rules>({exportWidth:480, exportHeight: 270, rules: [], exportImages: true, lineSize:3, backgroundColor: "black"});

            const currentProject = computed<Project>(() => store.state.currentProject);
            const isHiding = ref(false);
            const thumbsRef = ref<InstanceType<typeof Thumbnail> & ThumbsExpose | null>(null);
            const presenceMap = ref<Record<number, Array<{ key: string; email: string }>>>({});
            const labelsRef = ref<InstanceType<typeof Labels> & { shakeWrong: () => void } | null>(null);
            const helpTimeoutId = ref<number | null>(null);
            const canCorrect = ref<boolean>(false);
            const canRevertValidation = ref<boolean>(false);
            const username = ref<string>("");
            const exportTotal = ref(0);
            const exportDone = ref(0);

            const shortcutToast = ref<{ show: boolean; combo: string; label: string }>({
                show: false,
                combo: "",
                label: ""
            });

            const SHORTCUT_LABELS: Record<string, string> = {
                "Shift+A": "Select All Lines",
                "Shift+S": "Select One Line",
                "Shift+Z": "Zoom Active",
                "Shift+W": "Draw On Line Point",
                "Shift+Q": "Split Line",
                "Ctrl+D":  "Delete Line",
                "Shift+H":  "Hide Drag Points"
            };
            
            let toastTimer: number | null = null;

            const presentUsers = computed(() => {
                const seen = new Map<string, { key: string; email: string | null }>();
                for (const arr of Object.values(presenceMap.value)) {
                    for (const u of arr) if (!seen.has(u.key)) seen.set(u.key, u);
                }
                return Array.from(seen.values());
            });

            const exportPercent = computed(() => {
                const t = exportTotal.value || 0;
                if (!t) return 0;
                return Math.min(100, Math.round((exportDone.value / t) * 100));
            });

            const exportLabel = computed(() => {
                const t = exportTotal.value || 0;
                if (!t) return "";
                return `Export: ${exportDone.value}/${t} (${exportPercent.value}%)`;
            });

            function navToAdmin() {
                if (confirm(`Leaving editor. Do you wish to proceed?`)) {
                    router.push({path: "/admin" });
                }
            }

            async function navToLogout() {
                if (confirm(`Leaving editor. Do you wish to proceed?`)) {
                    try {
                        const { error } = await supabase.auth.signOut();
                        if (error) {
                            console.error("Error logging out:", error.message);
                            return;
                        }
                        router.push("/");
                    } catch (err) {
                        console.error("Unexpected error during logout:", err);
                    }
                }
            }

            function onLabelFocus(line:Line) {
                highlightedLine.value = line;
            }

            function onNewLine(line: Line){
                newLine.value = line;
            }

            function onDeleteLine(line: Line){
                oldLine.value = line;
            }

            async function onLabelChanged(lineId: number, oldLabel: string, newLabel: string) {
                if (!lineId || !canvasRef.value) return;
                try {
                    await canvasRef.value?.updateLineLabel(lineId, newLabel);
                } catch (e) {
                    console.error("Erro a atualizar label via ImageCanvas:", e);
                }
            }

            function showOptions() {
                optionsMenuVisible.value = !optionsMenuVisible.value;
                if (optionsMenuVisible.value) {
                    settingsMenuVisible.value = false; 
                }                
            }

            function showSettings() {
                settingsMenuVisible.value = !settingsMenuVisible.value;
                if (settingsMenuVisible.value) {
                    optionsMenuVisible.value = false;
                }                
            }

            function closeMenus(event: Event) {
                const target = event.target as HTMLElement;
                if (
                    !target.closest(".options-menu") && 
                    !target.closest(".settings-menu") && 
                    !target.closest(".menubar-options") && 
                    !target.closest(".menubar-settings")
                ) {
                    optionsMenuVisible.value = false;
                    settingsMenuVisible.value = false;
                }
            }

            async function loadRules() {
                if (currentProject.value) {
                    rules.value = await ProjectService.rebuildAndGetRules(currentProject.value.id as number);
                }
            }

            async function openRules() {
                settingsMenuVisible.value = false;
                if (currentProject.value) {
                    loadRules();
                    isOpenRules.value = true;
                }
            }

            async function onThumbnailSelected(image:ImageInfo) {
                selectedThumbnail.value = image;
                const pid = currentProject.value?.id;
                if (pid) {
                    username.value = await ProjectService.getUserNameById(selectedThumbnail.value.invalidated_by);
                    await ProjectService.trackPresenceSelection(pid, image.id);
                }
            }

            function goHome() {
                router.push({name: "home"});
            }

            function autoIncrementColors() {
                if (confirm(`All colors will be changed, do you wish to proceed?`)) {
                    let ctr = 0;
                    rules.value.rules.forEach(item => {
                        ctr += 10;

                        const r = Math.min(ctr, 255);
                        const g = Math.min(ctr, 255);
                        const b = Math.min(ctr, 255);

                        item.color = `#${r.toString(16).padStart(2, '0')}${g.toString(16).padStart(2, '0')}${b.toString(16).padStart(2, '0')}`;
                    });
                }
            }

            function deleteRule(rule:Rule) {
                rules.value.rules = rules.value.rules.filter(item => item.label !== rule.label);
            }

            function saveRules() {
                if (currentProject.value) {
                    ProjectService.saveRules(currentProject.value.id as number, rules.value);
                }
            }

            function distance(p1:Point, p2:Point) {
                const dx = p2.x - p1.x;
                const dy = p2.y - p1.y;
                return Math.sqrt(dx * dx + dy * dy);
            }

            function quadraticCurveToSegments(p0:Point, p1:Point, p2:Point): Point[] {
                // Calculated the total sistance between points
                const totalDistance = distance(p0, p1) + distance(p1, p2);
                
                // Try to estimate the number of segments (0.1 is arbitrary)
                const segmentsCount = Math.ceil(totalDistance / 10);
                
                let points = [] as Point[];
                for (let i = 0; i <= segmentsCount; i++) {
                    let t = i / segmentsCount;
                    let x = Math.pow(1 - t, 2) * p0.x + 2 * (1 - t) * t * p1.x + Math.pow(t, 2) * p2.x;
                    let y = Math.pow(1 - t, 2) * p0.y + 2 * (1 - t) * t * p1.y + Math.pow(t, 2) * p2.y;
                    points.push({ x, y });
                }
                return points;
            }

            function convertQuadraticLinesToSegments(lines: Line[]):Segment[] {
                const segments = [] as Segment[];
                lines.forEach(line => {
                    const points = quadraticCurveToSegments(line.start, line.middle, line.end) as Point[];
                    segments.push({label: line.label ,points:points});
                });

                return segments;
            }

            function segmentsToCsv(segments: Segment[], imageWidth:number, imageHeight:number, canvasWidth: number, canvasHeight: number): string {
                let csvContent = "Start x,End x,Start y,End y,Label\n";

                const scaleX = imageWidth / canvasWidth;
                const scaleY = imageHeight / canvasHeight;

                segments.forEach((segment: Segment) => {
                    for (let i = 0; i < segment.points.length - 1; i++) {
                    const start: Point = {
                        x: segment.points[i].x * scaleX,
                        y: segment.points[i].y * scaleY,
                    };
                    const end: Point = {
                        x: segment.points[i + 1].x * scaleX,
                        y: segment.points[i + 1].y * scaleY,
                    };

                    csvContent += `${start.x},${end.x},${start.y},${end.y},${segment.label}\n`;
                    }
                });

                return csvContent;
            }

            function exportOriginalImages(url:string, width:number, height:number): Promise<Blob> {
                return new Promise((resolve, reject) => {
                    const img = new Image();
                    img.crossOrigin = "anonymous";

                    img.onload = () => {
                        try {
                            const elem = document.createElement('canvas');
                            elem.width = width;
                            elem.height = height;
                            const ctx = elem.getContext('2d');
                            ctx?.drawImage(img, 0, 0, width, height);
                            ctx?.canvas.toBlob(blob => {
                                if (blob) {
                                    resolve(blob);
                                } else {
                                    throw new Error('Could not create blob of image.');
                                }
                            }, 'image/png');
                        } catch (e: any) {
                            reject(new Error(e?.message || String(e)));
                        }
                    };
                    img.onerror = () => {
                        reject(new Error(`Failed to load image for export: ${url}`));
                    };

                    img.src = url;
                });
            }
            
            async function createAndDownloadZipCSV() {
                if (!currentProject.value) return;

                exporting.value = true;
                exportDone.value = 0;
                exportTotal.value = 0;

                await loadRules();

                const images = await ProjectService.getValidatedProjectImageData(
                    currentProject.value.id as number
                );

                if (!images.length) {
                    exporting.value = false;
                    alert("No validated images.");
                    return;
                }

                exportTotal.value = images.length;
                await nextTick();

                const zip = new JSZip();

                const pngSemaphore = new Semaphore(2); // 1 = secure or 2 if server holds

                const tasks: ExportTask[] = [];

                await Promise.all(images.map(async (imageInfo) => {
                    const baseName = imageInfo.imageName.replace(/\.[^/.]+$/, "");

                    // NON-TRACKABLE
                    if ((imageInfo as any).is_non_trackable) {
                        tasks.push({ baseName, csv: "" });
                        return;
                    }

                    const visibleLines = imageInfo.lines.lines.filter(l => !l.is_hidden);
                    if (!visibleLines.length) return;

                    const segments = convertQuadraticLinesToSegments(visibleLines);
                    const csv = segmentsToCsv(segments, rules.value.exportWidth, rules.value.exportHeight, imageInfo.lines.canvasWidth, imageInfo.lines.canvasHeight);

                    tasks.push({ baseName, csv });
                }));

                for (const task of tasks) {
                    const imageInfo = images.find(i => i.imageName.startsWith(task.baseName));
                    if (!imageInfo) continue;

                    if (rules.value.exportImages) {
                        task.png = await pngSemaphore.use(() => exportOriginalImages(imageInfo.imageUrl, rules.value.exportWidth, rules.value.exportHeight));
                    }

                    exportDone.value++;
                    await new Promise(requestAnimationFrame);
                }

                for (const task of tasks) {
                    zip.file(task.baseName + ".csv", task.csv ?? "");
                    if (task.png) {
                        zip.file(task.baseName + ".png", task.png);
                    }
                }

                const blob = await zip.generateAsync({ type: "blob" });
                saveAs(blob, currentProject.value.project_name + ".zip");

                exporting.value = false;
                exportDone.value = 0;
                exportTotal.value = 0;
            }

            function hashStr(str: string): number {
                let h = 2166136261;
                for (let i = 0; i < str.length; i++) { h ^= str.charCodeAt(i); h = (h * 16777619) >>> 0; }
                return h >>> 0;
            }

            function colorForUser(keyOrEmail: string): { h: number; s: number; l: number } {
                const seed = hashStr(keyOrEmail || 'anon');
                const hue = Math.floor((seed * 137.508) % 360);
                return { h: hue, s: 70, l: 50 };
            }

            function textColorForL(l: number): string {
                 return l < 60 ? '#ffffff' : '#111111'; 
            }

            function dotStyle(u: { key: string; email: string | null }) {
                const basis = u.key || u.email || 'anon';
                const { h, s, l } = colorForUser(basis);
                return { backgroundColor: `hsl(${h} ${s}% ${l}%)`, color: textColorForL(l), borderColor: 'rgba(0,0,0,0.35)' };
            }

            async function subscribePresence() {
                if (!currentProject.value?.id) return;
                const pid = currentProject.value.id;

                const cb = (map: Record<number, Array<{ key: string; email: string }>>) => {
                    presenceMap.value = map || {};
                };

                if (typeof (ProjectService as any).subscribeToPresence === 'function') {
                    await (ProjectService as any).subscribeToPresence(pid, cb);
                } else if (typeof (ProjectService as any).subscribePresence === 'function') {
                    await (ProjectService as any).subscribePresence(pid, cb);
                } else {
                    console.warn('[EditorView] Presence subscription method not found on ProjectService.');
                }
            }

            async function onPresenceBadgeClick(u: { key: string; email: string | null }) {
                let targetImageId: number | null = null;
                for (const [imgIdStr, users] of Object.entries(presenceMap.value)) {
                    if (users.some(x => x.key === u.key)) { targetImageId = Number(imgIdStr); break; }
                }
                if (targetImageId != null) {
                    await nextTick();
                    thumbsRef.value?.scrollToImage?.(targetImageId);
                } else {
                    console.warn('User sem image_id presente neste projeto agora.');
                }
            }            

            function buildShortcutsHelp(): string {
                const pairs = Object.entries(SHORTCUT_LABELS);
                return pairs.map(([combo, desc]) => `${combo} — ${desc}`).join('\n');
            }

            function showShortcutsHelp() {
                if (helpTimeoutId.value) {
                    window.clearTimeout(helpTimeoutId.value);
                    helpTimeoutId.value = null;
                }

                showShortcutToast('F1', buildShortcutsHelp());

                helpTimeoutId.value = window.setTimeout(() => {
                    helpTimeoutId.value = null;
                    hideShortcutToast();
                }, 3000);
            }

            function comboFromEvent(e: KeyboardEvent): string {
                const parts: string[] = [];
                if (e.ctrlKey || e.metaKey) parts.push("Ctrl");
                if (e.shiftKey) parts.push("Shift");
                if (e.altKey) parts.push("Alt");

                const base = e.key.length === 1 ? e.key.toUpperCase() : e.key === " " ? "Space" : e.key.length ? e.key : "";

                if (!base) return "";
                parts.push(base);
                return parts.join("+");
            }

            function showShortcutToast(combo: string, label: string) {
                shortcutToast.value = { show: true, combo, label };
                isHiding.value = false;
            }

            function hideShortcutToast() {
                if (isHiding.value || !shortcutToast.value.show) return;

                isHiding.value = true;
                
                window.setTimeout(() => {
                    shortcutToast.value.show = false;
                    isHiding.value = false;
                    shortcutToast.value.combo = "";
                    shortcutToast.value.label = "";
                }, 220);
            }

            function onGlobalKeydown(e: KeyboardEvent) {
                if ((e.ctrlKey || e.metaKey) && e.key === 'F1') {
                    if (e.cancelable) e.preventDefault();
                    showShortcutsHelp();
                    return;
                }

                const combo = comboFromEvent(e);
                const label = SHORTCUT_LABELS[combo];
                if (!label) return;

                if (helpTimeoutId.value) {
                    window.clearTimeout(helpTimeoutId.value);
                    helpTimeoutId.value = null;
                }                

                showShortcutToast(combo, label);
            }
            
            function onGlobalKeyup(e: KeyboardEvent) {
                const k = e.key.length === 1 ? e.key.toUpperCase() : e.key;
                const released = new Set([
                    "Control","Meta","Shift","Alt","AltGraph", // Modifiers
                    "A","S","Z","W","Q","D", "H"                    // Main
                ]);
                if (released.has(k)) hideShortcutToast();
            }

            async function unvalidateSelected() {
                if (!selectedThumbnail.value) return;
                const id = selectedThumbnail.value.id;

                await ProjectService.unvalidateImage(id);

                const updated = { ...selectedThumbnail.value, is_validated: false, validated_by: null, validated_at: null } as ImageInfo;
                selectedThumbnail.value = updated;
            }

            async function markCorrected() {
                if (!selectedThumbnail.value) return;
                const id = selectedThumbnail.value.id;

                try {
                    const hasWrong = await ProjectService.hasWrongAnnotations(id);
                    if (hasWrong) {
                        labelsRef.value?.shakeWrong?.();

                        return;
                    }
                } catch (e) {
                    console.error('Falha a verificar labels errados:', e);
                    labelsRef.value?.shakeWrong?.();
                    return;
                }

                try {
                    await ProjectService.clearInvalidation(id);
                    const updated = { ...selectedThumbnail.value, is_invalidated: false, invalidate_notes: null } as ImageInfo;
                    selectedThumbnail.value = updated;
                } catch (e) {
                    console.error("Erro a limpar invalidation:", e);
                }
            }

            async function onThumbRequestDelete(imageId: number) {
                if (!currentProject.value?.id) return;

                try {
                    await ProjectService.deleteAllAnnotations(imageId);
                    await ProjectService.deleteImages(currentProject.value.id, [imageId]);
                    await ProjectService.updateProjectImageCountFromTable(currentProject.value.id);

                    await ProjectService.trackPresenceSelection(currentProject.value.id, null);
                } catch (e) {
                    console.error("Error deleting image:", e);
                    alert("Failed to delete image. See console for details.");
                }
            }

            async function onThumbRequestUpload(files: File[]) {
                if (!currentProject.value?.id) return;

                try {
                    const meta = await ProjectService.uploadImagesToSupabaseStorage(currentProject.value.id, files);

                    if (meta.length) {
                        await ProjectService.insertProjectImagesMetadata(currentProject.value.id, meta);
                        await ProjectService.updateProjectImageCountFromTable(currentProject.value.id);
                    }
                } catch (e) {
                    console.error("Erro no upload:", e);
                    alert("Falha no upload. Vê a consola para detalhes.");
                }
            }

            onMounted(async () => {
                try {
                    //const { data: auth } = await supabase.auth.getUser();
                    const { data: { session }, error: authError } = await supabase.auth.getSession();
                    const user = session?.user ?? null;
                    canCorrect.value = !!user;
                } catch {
                    canCorrect.value = false;
                }

                try {
                    isAdmin.value = await ProjectService.isCurrentUserAdmin();
                    const reviewer = await ProjectService.isCurrentUserReviewer(currentProject.value?.id);
                    console.log(reviewer);
                    canRevertValidation.value = isAdmin.value || reviewer;
                } catch {
                    canRevertValidation.value = isAdmin.value;
                }

                window.addEventListener("keydown", onGlobalKeydown);
                window.addEventListener("keyup", onGlobalKeyup);
                window.addEventListener("blur", hideShortcutToast);
                document.addEventListener("visibilitychange", () => { if (document.hidden) hideShortcutToast(); });

                await subscribePresence();

                document.addEventListener("click", closeMenus);
            });

            onBeforeUnmount(async () => {
                document.removeEventListener("click", closeMenus);
                window.removeEventListener("keydown", onGlobalKeydown);
                window.removeEventListener("keyup", onGlobalKeyup);
                window.removeEventListener("blur", hideShortcutToast);
                document.removeEventListener("visibilitychange", hideShortcutToast as any);

                if (currentProject.value?.id) {
                    try {
                    if ((ProjectService as any).unsubscribeFromPresence) {
                        await (ProjectService as any).unsubscribeFromPresence(currentProject.value.id);
                    } else if ((ProjectService as any).unsubscribePresence) {
                        await (ProjectService as any).unsubscribePresence(currentProject.value.id);
                    }
                    } catch {}
                }
            });           

            return { goHome, loading, exporting, onThumbnailSelected, selectedThumbnail, showOptions, showSettings, 
                     optionsMenuVisible, settingsMenuVisible,openRules, navToAdmin, navToLogout, currentProject, highlightedLine,
                     onLabelFocus, onLabelChanged, onNewLine, onDeleteLine, newLine, oldLine, rules, isOpenRules, deleteRule, saveRules,
                     autoIncrementColors, createAndDownloadZipCSV, presentUsers, dotStyle, onPresenceBadgeClick, thumbsRef,
                     shortcutToast, isHiding, unvalidateSelected, isAdmin, canvasRef, markCorrected, presenceMap, 
                     onThumbRequestDelete, onThumbRequestUpload, labelsRef, canCorrect, canRevertValidation, username,
                     exportTotal, exportDone, exportPercent, exportLabel };
        }
    });
</script>

<style lang="scss" scoped>
    .editor-main {
        display: flex;
        flex-direction: column;
        height: 100vh;
        width: 100vw;
    }

    .menubar-area {
        display: flex;
        flex-direction: row;
        height: 35px;
        width: 100%;
        background: #252525;
        border-bottom: 2px solid #9e9e9e;
        flex-shrink: 0;
    }

    .menubar-logo {
        display: flex;        
        justify-content: start;
        align-items: center;
        margin-left: 20px;
    }

    .menubar-logo img {
        width: 30px;
        height: auto;
    }

    .menubar-logo label {
        color: white;
        font-family: sans-serif;
        font-weight: bold;
    }

    .menubar-logo span {
        color: white;
        font-family: sans-serif;
        font-weight: bold;
    }

    .menubar-logo img:hover,
    .menubar-logo label:hover{
        cursor: pointer;
    }

    .menubar-items {
        padding-left: 15px;
        display: flex;
        align-items: center;
        margin-left: 20px;
        margin-top: 2px;
        color: rgb(192, 192, 192);
    }

    .menubar-items img {
        width: 25px;
        height: auto;
        padding-top: 4px;
        padding-left: 8px;
        padding-right: 4px;
        transition: background-color 1.0s;
    }

    .menubar-items img:hover {
        background: #565656;
    }

    .menubar-options-disable {
        opacity: 40%;
        pointer-events: none;
    }

    .menubar-settings-disable {
        opacity: 40%;
        pointer-events: none;
    }

    .options-menu {
        display: flex;
        align-content: center;
        justify-content: start;
        flex-direction: column;
        top: 36px;
        left: 156px;
        position: fixed;
        z-index: 1000;
        background-color: #323232;
        border: 1px solid #ccc;
        box-shadow: 0 2px 5px rgba(0,0,0,.2);
    }

    .options {
        display: flex;
        align-content: center;
        justify-content: start;
        flex-direction: row;
    }

    .options-menu img {
        width: 28px;
        height: auto;
    }

    .options-menu label {
        margin-top: 6px;
        font-family: sans-serif;
        color: white;
        margin-left: 8px;
    }

    .options-menu span {
        margin-top: 6px;
        font-family: sans-serif;
        color: white;
        margin-left: 8px;
    }

    .options-menu ul {
        list-style-type: none;
        margin: 0;
        padding: 0;
    }

    .options-menu ul li {
        padding: 8px 12px;
        cursor: pointer;
    }

    .options-menu ul li:hover {
        background-color: grey;
    }

    .settings-menu {
        display: flex;
        align-content: center;
        justify-content: start;
        flex-direction: column;
        top: 36px;
        left: 195px;
        position: fixed;
        z-index: 1000;
        background-color: #323232;
        border: 1px solid #ccc;
        box-shadow: 0 2px 5px rgba(0,0,0,.2);
    }

    .settings {
        display: flex;
        align-content: center;
        justify-content: start;
        flex-direction: row;
    }

    .settings-menu img {
        width: 28px;
        height: auto;
    }

    .settings-menu label {
        margin-top: 6px;
        font-family: sans-serif;
        color: white;
        margin-left: 8px;
    }

    .settings-menu span {
        margin-top: 6px;
        font-family: sans-serif;
        color: white;
        margin-left: 8px;
    }

    .settings-menu ul {
        list-style-type: none;
        margin: 0;
        padding: 0;
    }

    .settings-menu ul li {
        padding: 8px 12px;
        cursor: pointer;
    }

    .settings-menu ul li:hover {
        background-color: grey;
    }

    .editor-area {
        display: flex;
        flex-direction: row;
        flex-grow: 1;
        min-height: 0;
        background: #151515;
    }

    .left-side-bar {
        width: 290px;
        height: 100%;
        overflow-y: hidden;
        background: #282828;
        flex-shrink: 0;
    }

    .middle-side {
        flex-grow: 1; /* Take the remaining space */
        height: 100%; /* Full height */
        display: flex;
        justify-content: center; /* Center horizontally */
        align-items: center; /* Center vertically */
        background-color: #151515; /* Light background for contrast */
        border-left: 2px solid #4d4d4d;
        border-right: 2px solid #4d4d4d;
    }

    .right-side-bar {
        flex-shrink: 0;
        width: 250px;
        height: 100%;
        background-color: #282828;
        display: flex;
        align-items: center;
        justify-content: start;
        flex-direction: column;
    }

    .labels-container {
        display: flex;
        width: 100%;
        height: 98.5%;
        align-items: start;
        justify-content: center;        
        flex-shrink: 0;
    }

    // Wait Spinner
    .loader {
        z-index: 5;
        color: #FFF;
        display: inline-block;
        position: absolute;
        font-family: Arial, Helvetica, sans-serif;
        font-size: 48px;
        letter-spacing: 4px;
        box-sizing: border-box;
    }

    .exporter {
        z-index: 5;
        color: #FFF;
        display: inline-block;
        position: absolute;
        font-family: Arial, Helvetica, sans-serif;
        font-size: 60px;
        letter-spacing: 4px;
        box-sizing: border-box;
        margin-top: -110px;
    }

    .loader::before {
    content: '';  
        position: absolute;
        right: 68px;
        bottom: 10px;
        height: 24px;
        width: 7px;
        outline: 1px solid #FFF;
        color: #3769c5;
        box-sizing: border-box;
        animation: animloader1 1s linear infinite alternate;
    }
        .loader::after {
        content: '';  
        width: 4px;
        height: 4px;
        background: #3769c5;
        position: absolute;
        right: 70px;
        top: 8px;
        box-sizing: border-box;
        animation: animloader 1s ease-out infinite alternate;
    }

    @keyframes animloader {
        0% {
            top: 8px;
            transform: rotate(0deg) scale(1);
        }
        100% {
            top: 0px;
            transform: rotate(180deg) scale(1.5);
        }
    }

    @keyframes animloader1 {
        0% {
            box-shadow: 0 0 inset;
        }
        100% {
            box-shadow: 0 -28px inset;
        }
    }

    // Downloader
    .downloader {
        z-index: 5;
        width: 48px;
        height: 12px;
        background: #FFF;
        margin-top: 40px;
        display: inline-block;
        position: absolute;
        margin-top: 10%;
    }
    .downloader::after {
    content: '';  
        left: 50%;
        bottom: 0;
        transform: translate(-50%, 0);
        position: absolute;
        border: 15px solid transparent;
        border-top-color: #FFF;
        box-sizing: border-box;
        animation: bump 0.4s ease-in-out infinite alternate;
    }
    .downloader::before {
    content: '';  
        left: 50%;
        bottom: 25px;
        transform: translate(-50%, 0);
        position: absolute;
        width: 15px;
        height: 20px;
        background: #FFF;
        box-sizing: border-box;
        animation: bump 0.4s ease-in-out infinite alternate;
    }

    @keyframes bump {
        0% {
            transform: translate(-50%, 5px);
        }
        100% {
            transform: translate(-50%, -5px);
        }
    }

    .modal {
        width: 50%;
        min-width: 500px;
        
        position: fixed;
        top: 50%;
        left: 50%;
        transform: translate(-50%, -50%);

        overflow: hidden;
    }

    .rules-global-options {
        display: flex;
        flex-direction: column;
        gap: 10px;
    }

    .rule-row {
        display: flex;
        align-items: center;
        gap: 10px;
    }

    .center-input {
        text-align: center;
    }

    .inline-inputs {
        display: flex;
        align-items: center;
        gap: 5px;
    }

    .multiplier {
        font-weight: bold;
    }

    .color-picker {
        width: 30px;
        height: 30px;
        border: none;
        background: none;
        cursor: pointer;
        padding: 0;
    }

    .color-picker::-webkit-color-swatch {
        border-radius: 5px;
        border: none;
    }

    .color-picker::-moz-color-swatch {
        border-radius: 5px;
        border: none;
    }
    
    .color-input {
        color: lightgray;
        margin-left: 0;
        background-color: transparent;
        border: none;
        border-bottom: 1px solid lightgray;
        margin-bottom: 5px;
        text-align: center;
        width: 80px;
    }

    .color-input:focus {
        outline: none;
    }

    .rule-header {
        display: flex;
        justify-content: space-between;
        align-items: center;
        padding: 8px 12px;
        border-bottom: 1px solid lightgray;
        margin-bottom: 5px;
        gap: 10px;
    }

    .rule-header-text {
        flex: 1;
        text-align: left;
    }

    .rule-fill-colors-icon {
        padding-right: 100px;
        font-size: 20px;
        cursor: pointer;
        color: #7e7e7e;
        transition: color 0.3s;
    }

    .rule-fill-colors-icon:hover {
        color: #dddddd;
    }

    .rule-save-icon {
        font-size: 20px;
        cursor: pointer;
        color: #7e7e7e;
        transition: color 0.3s;
    }

    .rule-save-icon:hover {
        color: #dddddd;
    }

    .rule-list {
        width: 100%;
        list-style-type: none; // Remove bullet points
        padding: 0;
        max-height: 800px;
        overflow-y: auto;
    }

    .rule-list::-webkit-scrollbar {
        width: 8px;
    }

    .rule-list::-webkit-scrollbar-track {
        background: transparent;        /* color of the tracking area */
    }

    .rule-list::-webkit-scrollbar-thumb {
        background-clip: content-box;
        background-color: rgb(80, 80, 80);    /* color of the scroll thumb */
    }

    .rule-listcontent::-webkit-scrollbar-thumb:hover {
        background-color: rgb(180, 180, 180);    /* color of the scroll thumb */
    }

    .rule-item {
        display: flex;
        justify-content: space-between;
        align-items: center;
        padding: 5px 10px;
        border-radius: 5px;
        transition: background-color 0.3s ease;
    }

    .rule-color {
        display: flex;
        flex-direction: row;
        justify-content: space-between;
        align-items: center;
    }

    .rule-size {
        display: flex;
        flex-direction: row;
        align-items: center;
    }

    .rule-options {
        display: flex;
        flex-direction: row;
        align-items: center;
    }

    .color-delete {
        margin-left: 20px;
    }

    .color-delete:hover {
        color: grey;
    }

    .switch {
        position: relative;
        display: inline-block;
        width: 40px;
        height: 20px;
    }

    .switch input {
        opacity: 0;
        width: 0;
        height: 0;
    }

    .slider {
        position: absolute;
        cursor: pointer;
        top: 0; left: 0; right: 0; bottom: 0;
        background-color: #5a5a5a;
        transition: .4s;
        border-radius: 20px;
    }

    .slider:before {
        position: absolute;
        content: "";
        height: 14px;
        width: 14px;
        left: 3px;
        bottom: 3px;
        background-color: white;
        transition: .4s;
        border-radius: 50%;
    }

    input:checked + .slider {
        background-color: rgb(58, 58, 83);
    }

    input:checked + .slider:before {
        transform: translateX(20px);
    }

    .menubar-presence {
        margin-left: auto;
        display: flex; align-items: center; gap: 6px;
        padding-right: 12px;
    }

    .presence-dot {
        width: 18px; height: 18px; border-radius: 50%;
        font-size: 11px; font-weight: 700;
        display: flex; align-items: center; justify-content: center;
        border: 1px solid rgba(0,0,0,0.35);
        user-select: none;
    }

    .shortcut-toast {
        position: fixed;
        right: 16px;
        bottom: 16px;
        z-index: 2000;
        display: inline-flex;
        align-items: center;
        gap: 10px;

        padding: 10px 12px;
        border-radius: 10px;
        background: rgba(30, 30, 30, 0.92);
        color: #fff;
        border: 1px solid rgba(255,255,255,0.12);
        box-shadow: 0 6px 22px rgba(0,0,0,0.35);

        /* só anima a entrada; não desaparece sozinho */
        animation: toastIn 140ms ease-out;
    }

    .shortcut-toast.is-hiding 
    { 
        animation: toastOut 220ms ease-in forwards; 
    }    

    .shortcut-kbd {
        font-family: ui-monospace, SFMono-Regular, Menlo, Consolas, monospace;
        font-size: 12px;
        line-height: 1;
        padding: 6px 8px;
        border-radius: 6px;
        background: #2f2f2f;
        border: 1px solid rgba(255,255,255,0.12);
        opacity: .95;
    }

    .shortcut-desc {
        font-size: 13px;
        opacity: .95;
        white-space: pre-line;
    }

    @keyframes toastIn {
        from { transform: translateY(20px); opacity: 0; }
        to   { transform: translateY(0);   opacity: 1; }
    }

    @keyframes toastOut {
        to   { transform: translateY(20px); opacity: 0; }
    }

    @media (prefers-reduced-motion: reduce) {
        .shortcut-toast { animation: none; }
    }

    .validated-overlay {
        position: absolute;
        top: 42px;
        left: 50%;
        transform: translateX(-50%);
        z-index: 150;
        display: flex;
        flex-direction: column;
        align-items: center;
        gap: 8px;
    }

    .validated-badge {
        background: #334155;
        color: #fff;
        padding: 4px 10px;
        border-radius: 6px;
        font-size: 12px;
    }

    .export-progress {
        position: absolute;
        z-index: 6;
        margin-top: 240px;
        width: min(520px, 80vw);
    }

    .export-progress-label {
        color: #fff;
        font-family: Arial, Helvetica, sans-serif;
        font-size: 14px;
        opacity: 0.95;
        margin-bottom: 8px;
        text-align: center;
    }

    .export-progress-bar {
        height: 10px;
        border-radius: 999px;
        background: rgba(255,255,255,0.18);
        border: 1px solid rgba(255,255,255,0.22);
        overflow: hidden;
    }

    .export-progress-fill {
        height: 100%;
        width: 0%;
        background: #3769c5; /* combina com o teu loader */
        transition: width 120ms linear;
    }
</style>